angular.module('bmsApp.accounting')
	.controller('InvoiceIndexCustomerRowCtrl', [
		'$scope',
		'$state',
		function ($scope,
				  $state) {

			$scope.goToCustomer = function (customerId) {
				$state.go('main.crm.customer.index.view', {
					'customerId': customerId
				});
			}

		}
	]);
